import {Auditable} from "./auditable";

/**
 * User (profile) data.
 */
export class User extends Auditable {
  name: string;
  imageUrl: string;
  isAdmin: boolean;
}



// WEBPACK FOOTER //
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/class/user.ts